///ts:ref=AnyFunc
/// <reference path="./AnyFunc.ts"/> ///ts:ref:generated
///ts:ref=PandaConsole
/// <reference path="../console/PandaConsole.ts"/> ///ts:ref:generated
namespace ChainerSync {
    export function chain(thisArg: any, first: AnyFunc, second: AnyFunc, ...anotherFuncs: AnyFunc[]): AnyFunc;
    export function chain(thisArg: any,...funcs: AnyFunc[]): AnyFunc {
        return function (...args: any[]): any {
            PandaConsole.here;
            let result:any;
            let l: number = funcs.length;
            for (let i: number = 0; i < l; i++) {
                let func:AnyFunc = funcs[i];
                if (!func) {
                    continue;
                }
                try  {
                    result = func.apply(thisArg, args);
                } catch (e) {
                    PandaConsole.errorUncritical(e);
                }
            }
            return result;
        }
    }
}